import { GridItem, LayoutGrid, TypographyV3 } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import Image from '@/app/components/Image';
import useMembershipPricing from '@/app/hooks/useMembershipPricing';

import styles from './MembershipBenefits.module.css';

const MembershipBenefits = (): JSX.Element => {
  const t = useTranslations();
  const membershipPricingValues = useMembershipPricing({ footnoteSymbol: '*' });

  return (
    <section
      className={cx(styles['grayGradient'], 'relative md:px-5')}
      data-cy="membership-benefits"
    >
      <LayoutGrid>
        <GridItem
          colStart={{ sm: 'main', lg: 'full' }}
          colEnd={{ sm: 'main', lg: 14 }}
          className="relative lg:flex lg:justify-around lg:py-14"
        >
          <div className="relative aspect-1000/987 w-full">
            <Image
              src="membership/membership_benefits_background@2x"
              format="png"
              alt={t('membership_benefit_alt')}
              loading="lazy"
              className="object-contain"
              fill
              sizes="(max-width: 767px) 100vw, 50vw"
              data-cy="benefit-ring-lines-extend"
            />
          </div>
        </GridItem>
        <GridItem
          colStart={{ sm: 'main', lg: 15 }}
          colEnd={{ sm: 'main', lg: 23 }}
          className="relative flex justify-around pt-8 pb-20 lg:py-14"
        >
          <div
            className="flex grow justify-center text-gray-500 sm:flex-col"
            data-cy="membership-benefits-text-section"
          >
            <div>
              <TypographyV3
                Element="h3"
                variant="body-large"
                weight={'bold'}
                className="pb-4 text-xl text-gray-500"
              >
                {t('membership_benefits_first_month_title')}
              </TypographyV3>
              <TypographyV3 className="pb-8 text-gray-500 md:text-xl lg:pb-14">
                {t.rich(
                  'membership_benefits_first_six_months_body_site_redesign_new',
                  membershipPricingValues,
                )}
              </TypographyV3>
            </div>

            <TypographyV3
              Element="h3"
              variant="body-large"
              weight={'bold'}
              className="pb-4 text-xl text-gray-500"
            >
              {t('membership_benefits_evolving_title')}
            </TypographyV3>
            <TypographyV3 className="pb-8 text-gray-500 md:text-xl lg:pb-14">
              {t('membership_benefits_evolving_body')}
            </TypographyV3>

            <TypographyV3
              Element="h3"
              variant="body-large"
              weight={'bold'}
              className="pb-4 text-xl text-gray-500"
            >
              {t('membership_benefits_nonpaying_members_title')}
            </TypographyV3>
            <TypographyV3 className="text-gray-500 md:text-xl lg:pb-14">
              {t('membership_benefits_nonpaying_members_body')}
            </TypographyV3>
          </div>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};
export default MembershipBenefits;
